import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { ThumbnailBig, FooterSection, InputWithButton2 } from "@components";
import "./ListNetwork.scss";
import { NetworkListAPI } from "@api";
import { useTranslation } from "react-i18next";
import { TitleComponent } from "../../../common/components/TitleComponent";
import MyMenu from "../MyMenu";
// import { useParams } from "react-router-dom";
import { Pagination, PaginationSearch } from "@components";
import { useQuery } from "@hooks";
import { Search } from "../../../common/icons";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const ListNetworkContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`;

const Card = styled.div`
  height: auto;
  background: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 5%) 0px -1px 2px, rgb(0 0 0 / 10%) 0px 2px 4px;
  border-radius: 8px;
`;

const CardTitle = styled.h3`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: rgb(94, 81, 77);
`;

const TextMuted = styled.span`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  color: rgb(138, 141, 143);
  margin-bottom: 6px;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 150%;
  color: rgb(94, 81, 77);
  margin-bottom: 0px;
`;

const Button = styled.a`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgb(0, 0, 0);
  background: rgb(242, 169, 0);
`;

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`;

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const ListNetwork = function (props) {
  const { t } = useTranslation();
  const [data, setdata] = useState({});
  const [total, setTotal] = useState("");
  const [isLoading, setisLoading] = useState(true);
  const query = useQuery();
  const page = query.get("page") || 1;
  const [search, setSearch] = useState(query.get("q") || "");
  const [isSearch, setIsSearch] = useState(false);

  useEffect(() => {    
    if(isSearch === true || query.get("q")!== null){
      loadDataSearch();      
    } else{
      loadData();
    }
  }, [isSearch]);

  const loadData = async function () {
    const { data } = await NetworkListAPI(props.item + `?page=${page}`);
    setdata(data.data);
    setisLoading(false);
    setTotal(data.data.page.totalPage);
  };

  const loadDataSearch = async function () {
    const { data } = await NetworkListAPI(props.item + `?q=${search}&page=${page}`);    
    setdata(data.data);
    setisLoading(false);
    setTotal(data.data.page.totalPage);    
  };

  const createPagination = () => {
    return {
      totalItems: total,
      currentPage: +page,
    };
  };

  const createPaginationSearch = () => {
    return {
      keySearch: search,
      totalItems: total,
      currentPage: +page,
    };
  };

  const doSearch = async () => {
    setIsSearch(true);    
  };

  return (
    <div>
      <TitleComponent
        title={
          isLoading
            ? ""
            : data.banner.judulBannerKantor
            ? data.banner.judulBannerKantor
            : data.banner.judulBannerATM
        }
      />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={
              isLoading
                ? ""
                : data.banner.judulBannerKantor
                ? data.banner.judulBannerKantor
                : data.banner.judulBannerATM
            }
            desc={
              isLoading
                ? ""
                : data.banner.deskripsiBannerKantor
                ? data.banner.deskripsiBannerKantor
                : data.banner.deskripsiBannerATM
            }
            img={
              isLoading
                ? ""
                : data.banner.imageBannerDesktopKantor
                ? data.banner.imageBannerDesktopKantor
                : data.banner.imageBannerDesktopATM
            }
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={
              isLoading
                ? ""
                : data.banner.judulBannerKantor
                ? data.banner.judulBannerKantor
                : data.banner.judulBannerATM
            }
            desc={
              isLoading
                ? ""
                : data.banner.deskripsiBannerKantor
                ? data.banner.deskripsiBannerKantor
                : data.banner.deskripsiBannerATM
            }
            img={
              isLoading
                ? ""
                : data.banner.imageBannerMobileKantor
                ? data.banner.imageBannerMobileKantor
                : data.banner.imageBannerMobileATM
            }
          />
        </Mobile>
      </Container>

      <ListNetworkContainer className="container-fluid">
        <div className="m-0 row d-flex align-items-start">
          <div className="p-0 col-lg-9 col-12 me-4">
            <div className="row">
              
              <div className="col-12 mb-5">
                <InputWithButton2
                  icon={Search}
                  placeholder={`${t('contoh')} : Jakarta, Senayan`}
                  buttonLabel={t("search")}
                  value={search}
                  setValue={setSearch}
                  doFunction={doSearch}
                  doReset="true"
                  doResetType={`/network/${props.item}`}
                />
              </div>

              <div className="col-12">
                {isLoading
                  ? []
                  : data.item?.map((item, index) => {
                      return (
                        <Card className="p-3 mb-3" key={index}>
                          <CardTitle className="mb-3">{item.judul}</CardTitle>
                          <div className="mb-3">
                            <TextMuted>{t("Alamat")}</TextMuted>
                            <Text>{item.alamat}</Text>
                          </div>
                          {props.item === "kantor" ? (
                            <div className="d-flex flex-column flex-lg-row">
                              <div className="d-flex w-50 mb-3">
                                <svg
                                  width="1.5em"
                                  height="1.5em"
                                  viewBox="0 0 24 24"
                                  fill="#5e514d"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M10.857 8.338c.518-.698.704-1.434.118-2.084-1.315-1.84-2.2-2.978-2.754-3.525-1.055-1.042-2.79-.901-3.703-.001-.49.483-.657.649-1.16 1.16C.552 6.697 2.263 12.63 6.812 17.184c4.547 4.552 10.48 6.264 13.292 3.45.465-.447.859-.841 1.169-1.169.895-.946 1.03-2.604-.006-3.682-.532-.552-1.617-1.393-3.534-2.765-.587-.525-1.284-.411-1.922.007-.307.202-.53.406-.952.828l-.767.767c-.1.1-1.47-.586-2.801-1.917C9.96 11.37 9.274 9.999 9.374 9.899l.767-.768c.134-.134.198-.198.28-.285.171-.18.313-.343.436-.508zm4.649 7.695l.766-.767a6.86 6.86 0 01.505-.474c1.68 1.206 2.653 1.965 3.05 2.378.239.248.202.7-.006.919-.287.303-.66.677-1.117 1.118-1.818 1.819-6.608.437-10.479-3.438-3.872-3.876-5.253-8.666-3.449-10.472.502-.509.66-.668 1.144-1.144.182-.179.676-.22.896-.001.427.422 1.22 1.436 2.385 3.06-.06.074-.136.159-.228.255-.067.071-.123.128-.246.25l-.766.767c-1.303 1.303-.193 3.52 1.916 5.632 2.108 2.11 4.326 3.22 5.629 1.917z"
                                  ></path>
                                </svg>
                                <Text className="ms-2">{item.telfon}</Text>
                              </div>
                              <div className="d-flex w-50 mb-3">
                                <svg
                                  width="1.5em"
                                  height="1.5em"
                                  viewBox="0 0 24 24"
                                  fill="#5e514d"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M4 7h2V2h12v5h2a2 2 0 012 2v8a2 2 0 01-2 2h-2v3H6v-3H4a2 2 0 01-2-2V9a2 2 0 012-2zm12 0H8V4h8v3zm4 2v8h-2v-2H6v2H4V9h16zm-4 8H8v3h8v-3zm3-6a1 1 0 10-2 0 1 1 0 002 0z"
                                  ></path>
                                </svg>
                                <Text className="ms-2">{item.fax}</Text>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="d-grid">
                            <Button
                              href={item.linkGmaps}
                              target="_blank"
                              className="btn btn-primary btn-lg"
                            >
                              {t("BukadiPeta")}
                            </Button>
                          </div>
                        </Card>
                      );
                    })}
                <nav
                  className="pagination-box d-flex align-items-center justify-content-center"
                  aria-label="News Pagination"
                >
                  <ul className="pagination">
                    {isSearch || query.get("q")!== null ? (
                      <PaginationSearch {...createPaginationSearch()} />
                    ) : (
                      <Pagination {...createPagination()} />
                    )}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block col">
            <MyMenu active={props.item === "kantor" ? 0 : 1} />
          </div>
        </div>
      </ListNetworkContainer>
      <FooterSection currentPage={props.item === "kantor" ? t("jaringan_kantor") : t("jaringan_atm")} />
    </div>
  );
};

export default ListNetwork;
